"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllotmentsEdit = exports.className = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const SearchUser_1 = require("../../Form/Field/SearchUser");
const utils_1 = require("../../Form/Field/SearchUser/utils");
const Sub_1 = require("../../Page/Title/Sub");
const Item_1 = require("./Item");
const utils_2 = require("./Seats/utils");
const TotalItem_1 = require("./TotalItem");
require("./index.scss");
exports.className = 'allotments-edit';
const AllotmentsEdit = (props) => {
    const { addAllotmentField, config, values = [], onChange, tariffGroups, totalSeats, removeHidden, setValidateRef, } = props;
    const validateArrayRef = (0, react_1.useRef)([]);
    validateArrayRef.current = Array(values.length).fill(() => false);
    setValidateRef === null || setValidateRef === void 0 ? void 0 : setValidateRef(() => validateArrayRef.current.map(validate => validate()).every(x => x));
    const allotmentsSeats = (0, utils_2.calcAllotmentsTotalSeats)(tariffGroups, values);
    return (react_1.default.createElement("div", { className: exports.className },
        react_1.default.createElement("div", { className: `${exports.className}__container` },
            react_1.default.createElement("div", { className: `${exports.className}__header` },
                react_1.default.createElement("div", { className: `${exports.className}__title` },
                    react_1.default.createElement(Sub_1.PageSubTitle, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/ListEdit:Title', defaultMessage: 'Allotments' }), icon: 'iconmonstr-retweet-1-2' })),
                react_1.default.createElement("div", { className: `${exports.className}__search` },
                    react_1.default.createElement(SearchUser_1.SearchUser, { ...addAllotmentField([]), toItem: utils_1.mapAgentToUserItem, placeholder: 'Search Agent', label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/ListEdit:AddAllotment', defaultMessage: 'Add Allotment' }) }))),
            react_1.default.createElement("div", { className: `${exports.className}__list` },
                react_1.default.createElement(TotalItem_1.AllotmentsEditTotalItem, { tariffs: (0, utils_2.subtractTotalSeats)(totalSeats, allotmentsSeats !== null && allotmentsSeats !== void 0 ? allotmentsSeats : []) }),
                (values === null || values === void 0 ? void 0 : values.length) ? undefined : (react_1.default.createElement("div", { className: `${exports.className}__list-placeholder` },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/ListEdit:NoAgentAllotments', defaultMessage: 'No agent allotments' }))), values === null || values === void 0 ? void 0 :
                values.map((x, index) => {
                    return (react_1.default.createElement(Item_1.AllotmentsEditItem, { key: x.tmpId, config: config, value: x, tariffGroups: tariffGroups, onChange: (value) => {
                            const newValues = values.map((y, i) => {
                                if (i !== index)
                                    return y;
                                return value;
                            });
                            onChange === null || onChange === void 0 ? void 0 : onChange(newValues);
                        }, remove: () => {
                            const newValues = values.filter((_, i) => i !== index);
                            onChange === null || onChange === void 0 ? void 0 : onChange(newValues);
                        }, removeHidden: removeHidden(x), setValidateRef: (validate) => validateArrayRef.current[index] = validate }));
                })))));
};
exports.AllotmentsEdit = AllotmentsEdit;
//# sourceMappingURL=index.js.map